import { playerFactory } from "./playerFactory";
let currentPlayer;
export function setPlayer(player) {
    currentPlayer = player;
    window.localStorage.setItem('player', JSON.stringify(player));
}
export function getPlayer() {
    if (!currentPlayer) {
        loadPlayer();
    }
    return currentPlayer;
}
function loadPlayer() {
    const json = window.localStorage.getItem('player');
    if (!json) {
        return;
    }
    const { name, preview, chatImage, sprite } = JSON.parse(json);
    currentPlayer = playerFactory(name, preview, chatImage, sprite);
}
